import React from "react";
import ContextStateNavBar from "../../components/NavBar/context/contextState";

const About = () => {
  const button = React.useContext(ContextStateNavBar);
  let color = button.state.About ? "rgba(111, 255, 233, 1)" : "rgba(91, 192, 190, 1)";
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 25 25"
      fill= {button.state.About ? "#fff" : "#000"}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_42_59)">
        <path
          d="M13.1017 0.00861263C14.3216 0.00861263 15.31 0.997401 15.31 2.21692C15.31 3.43645 14.3216 4.42484 13.1017 4.42484C11.8824 4.42484 10.8938 3.43645 10.8938 2.21692C10.8939 0.997401 11.8824 0.00861263 13.1017 0.00861263Z"
          fill={color}
        />
        <path
          d="M17.2431 22.7312C17.4272 23.1598 17.8448 23.416 18.2825 23.416C18.4317 23.416 18.5834 23.3868 18.7285 23.324C19.3026 23.0775 19.5682 22.4122 19.3216 21.8381L16.7727 15.9052C16.7103 15.76 16.6178 15.6291 16.5015 15.5217L12.7829 12.0808L13.3879 8.83262L14.022 10.6156C14.1424 10.9546 14.4404 11.1991 14.7964 11.2505C14.843 11.2574 14.8892 11.2607 14.9354 11.2607C15.2427 11.2607 15.535 11.1143 15.7187 10.8622L18.1022 7.58961C18.1318 7.54944 18.1536 7.50646 18.1759 7.46308C17.8394 7.39051 17.5138 7.26852 17.2159 7.08766C16.9442 6.92301 16.707 6.71952 16.5034 6.4909L15.2329 8.235L14.5559 6.33031C14.4537 6.04328 14.2291 5.83854 13.9632 5.7449L13.9655 5.73073C13.9655 5.73073 10.9516 4.70138 9.52312 4.28454L3.51749 0.169587C3.07543 -0.132867 2.47256 -0.0197303 2.16987 0.421776C1.86726 0.863751 1.97969 1.46654 2.42167 1.76939L8.75919 6.11187L8.63353 13.0831L8.68239 13.0729C8.70243 13.2761 8.77383 13.4763 8.90701 13.6503L12.3488 18.1432L10.1729 23.4392C9.93526 24.0165 10.2114 24.6777 10.7889 24.915C10.9296 24.9725 11.0749 25.0002 11.2187 25.0002C11.6636 25.0002 12.0856 24.7358 12.2653 24.2983L14.6889 18.4007C14.8421 18.0285 14.7853 17.6028 14.5404 17.2829L13.2407 15.5863L14.7889 17.0191L17.2431 22.7312Z"
          fill={color}
        />
        <path
          d="M20.3414 4.17587C19.9035 3.91029 19.4203 3.78345 18.9431 3.78345C18.4339 3.78345 17.9316 3.92775 17.4978 4.19904C17.4394 4.92194 17.6761 5.6468 18.1599 6.20019C18.3374 6.40336 18.5462 6.58493 18.7895 6.73251C19.0611 6.89717 19.3506 7.00208 19.6445 7.063C19.825 7.10027 20.0065 7.12501 20.1878 7.12501C20.6974 7.12501 21.1997 6.98063 21.6335 6.70942C21.7126 5.72102 21.2467 4.72565 20.3414 4.17587Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_42_59">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default About;
